import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseStorefrontModule } from "@spartacus/storefront";
import { SGRESharedModule } from './SGRE-shared/SGRE-shared.module';
import { GlobalService } from './SGRE-shared/services/global.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [BaseStorefrontModule, SGRESharedModule]
})
export class AppComponent implements OnInit {

  title = 'sgreshopspa';

  constructor(private globalService: GlobalService) { }

  ngOnInit(): void {

    this.globalService.restoreSessionAfterRefresh();
  }
}
